// Delegated, because the product listing gets replaced when filtering
export function priceRequest() {
	const openPriceRequest = (trigger) => {
		const dialog = document.getElementById('dialog-' + trigger.dataset.dialog)
		if (!dialog) return

		const field = dialog.querySelector('input[name="fields[general_model]"]')

		if (field) {
			const text = trigger.closest('.item')?.querySelector('.item__content__text')
			const details = text ? text.innerText.split('\n').map((line) => line.trim()).filter(Boolean) : []

			field.value = [trigger.dataset.priceRequest, ...details].join(' – ')
		}

		dialog.showModal()
	}

	document.addEventListener('click', (event) => {
		const trigger = event.target.closest('[data-price-request]')
		if (trigger) openPriceRequest(trigger)
	})

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Enter' && event.key !== ' ') return

		const trigger = event.target.closest('[data-price-request]')
		if (!trigger) return

		event.preventDefault()
		openPriceRequest(trigger)
	})
}
